import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {BulletedList} from 'shells/bulleted-list/bulleted-list';
import {Button} from 'shells/button/button';
import {Illustration} from 'shells/illustrations/illustration';
import {Link} from 'shells/link/link';
import {TwoPaneModal} from 'shells/modal/two-pane-modal';
import {Body} from 'shells/typography/body';
import {ModalHeader} from 'shells/typography/modal-header';

import styles from './customize-lead-cards-upsell.module.css';

type Props = {
    onClose: () => void;
};

export function CustomizeLeadCardsUpsell(props: Props) {
    return (
        <TwoPaneModal
            // @ts-expect-error
            isOpen={true}
            maxHeight={600}
            onClose={props.onClose}
            closeButton={false}
            leftSection={
                <div className={styles.left}>
                    <div style={{width: '260px'}}>
                        <Illustration src='lead-cards' width='100%' height='100%' />
                    </div>
                </div>
            }
            rightSection={
                <div className={styles.container}>
                    <ModalHeader>Pick the fields that work for you</ModalHeader>
                    <div className='mb-16'>
                        <Body>Upgrade to Nutshell Pro to unlock lead card customization.</Body>
                    </div>
                    <BulletedList
                        bullets={[
                            <span key='bullet-1'>Choose up to 8 fields on a card</span>,
                            <span key='bullet-2'>
                                Different configurations per pipeline, allowing teams with{' '}
                                <Link
                                    href='https://support.nutshell.com/en/articles/8429056-pipelines-working-with-multiple-pipelines'
                                    size='normal'
                                    variant='primary'
                                    newTab={true}
                                >
                                    multiple pipelines
                                </Link>{' '}
                                to work the way they want
                            </span>,
                            <span key='bullet-3'>
                                Pick from any Nutshell field or custom fields, and reorder the
                                fields however you’d like
                            </span>,
                        ]}
                    />
                    <div className={styles.footer}>
                        <Button
                            variant='text-secondary'
                            size='normal'
                            onClick={props.onClose}
                            noPadding={true}
                        >
                            Not right now
                        </Button>
                        <Link
                            // @ts-expect-error
                            as={RoutedLink}
                            variant='button-primary'
                            size='big'
                            to='/setup/billing/sales'
                        >
                            View billing
                        </Link>
                    </div>
                </div>
            }
        />
    );
}
